// generatorService.js
export const generateWorkoutService = async (fitnessLevel, focusArea, equipment, injuries, setButtonText, setButtonDisabled) => {
    const workoutInput = {
      fitnessLevel,
      areaOfFocus: focusArea, 
      equipmentAvailable: equipment, 
      personalInjuries: injuries, 
    };
  
    setButtonText("Generating...");
    setButtonDisabled(true);
  
    try {
      const token = localStorage.getItem("authToken"); 
  
      if (!token) {
        throw new Error("No auth token found");
      }
  
      const response = await fetch(`/api/v1/workout-generator`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(workoutInput),
      });
  
      if (!response.ok) {
        throw new Error(`API Error: ${response.statusText}`);
      }
  
      const workoutReturnPlan = await response.json();
      // console.log("Workout Service Plan:", workoutReturnPlan);

      setButtonText("Workout Ready!");
      return (workoutReturnPlan);
      // return JSON.parse(workoutReturnPlan).Structure;
    
    } catch (error) {
      console.error("Failed to generate workout plan:", error);
      setButtonText("Error AI Down");
    } finally {
      setButtonDisabled(false); 
    }
  };
  